
(function equalsDirectiveDefinition() {

    'use strict';

    angular.module('EqualsValidation', [])
        .directive('equals', [
            function() {
                return {
                    require: 'ngModel',
                    link: function(scope, elem, attrs, ctrl) {
                                                
                        var condition = attrs.ngModel + ' === ' + attrs.equals;

                        if (attrs.equalsCondition)
                            condition = attrs.equalsCondition + ' && ' + condition;

                        scope.$watch(condition, function (value) {
                            ctrl.$setValidity('equals', (value && true) || false );
                        });
                    }
                };
            }
        ]);

})();